/* eslint-disable max-lines-per-function */
import { useParams } from 'react-router-dom';
import { useFetchModelScenarios } from '../../../hooks/useFetchModelScenarios';
import { CenteredLoader } from '../../../components/CenteredLoader/CenteredLoader';
import { useFetchOrchestration } from '../../../hooks/useFetchOrchestration';
import { useFetchCategorizedImages } from '../../../hooks/useFetchCategorizedImages';
import { useFetchScenario } from '../../../hooks/useFetchScenario';
import { OutputFiles } from '../../Simulation/OutputFiles/OutputFiles';
import { GeneratedImages } from '../../Simulation/GeneratedImages/GeneratedImages';
import * as Styled from './SimulationView.styled';

export const SimulationView = () => {
  const { modelId } = useParams<{ modelId: string }>();

  const { data: scenarios, isLoading: scenariosLoading } =
    useFetchModelScenarios(modelId);

  const scenarioId = scenarios?.[0]?.scenario_id;

  const { data: scenario } = useFetchScenario(scenarioId);

  const { data: orchestration } = useFetchOrchestration(
    scenario?.orchestration_id,
  );

  const isProcessing = orchestration?.phase_status === 'Running';
  const isSimulationPhase = orchestration?.current_phase === 'Simulation';
  const isCompleted =
    !!orchestration &&
    orchestration?.phase_status !== 'Running' &&
    orchestration?.phase_status !== 'Failed';

  const { data: categorizedImages } = useFetchCategorizedImages(
    scenario?.orchestration_id,
    isProcessing,
  );

  if (scenariosLoading) {
    return <CenteredLoader size={24} />;
  }

  return (
    <Styled.Container>
      <Styled.ContentGrid>
        <Styled.FullWidthRow>
          <OutputFiles
            orchestrationId={orchestration?.delft_orchestration_id}
            enabled={isSimulationPhase || isCompleted}
            shouldPoll={isProcessing && isSimulationPhase}
          />
        </Styled.FullWidthRow>

        <Styled.FullWidthRow>
          <GeneratedImages
            images={categorizedImages}
            orchestrationId={scenario?.orchestration_id ?? undefined}
          />
        </Styled.FullWidthRow>
      </Styled.ContentGrid>
    </Styled.Container>
  );
};
